export default () => ({
    videoContainer: {
        height: '50vh'
    },
});
